// Make a whole table row act like a button that drills into something —
// clickable for the mouse, focusable + Enter/Space for the keyboard, with a
// subtle hover highlight. Pair the chevron affordance in the row's last cell.
export function drillRow(onActivate) {
    return {
        role: 'button',
        tabIndex: 0,
        onClick: onActivate,
        onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onActivate();
            }
        },
        className: 'group cursor-pointer transition-colors hover:bg-muted/60',
    };
}
// Spread onto the cell holding row controls (kebab, inline selects) so clicking
// or keyboarding them doesn't also trigger the row's drill.
export const stopRowActivate = {
    onClick: (e) => e.stopPropagation(),
    onKeyDown: (e) => e.stopPropagation(),
};
